import useAppStore from "@/context/store";
import classNames from "classnames";
import { useMemo } from "react";
import styles from "./index.module.less";

/**
 * 官方账号标识
 * @param param0
 * @returns
 */
export default function OfficialAccountTag({
  className,
  title = "花瓣官方",
  user,
}: {
  className?: string;
  title?: string;
  user?: IUser;
}) {
  const config = useAppStore((s) => s.config);

  const isOfficial = useMemo(() => {
    return config?.officialUsers?.split(",").includes(user?.urlname);
  }, [user, config]);

  if (!isOfficial) {
    return null;
  }

  return (
    <span
      className={classNames(styles.official, className)}
      title={title}
    ></span>
  );
}
